import { useCallback } from "react";
import { useAtom } from "jotai";
import type { VehicleSessionSnapshot } from "../../interface/auth_types";
import { remoteClientDataAtom } from "../atom/remoteClientDataAtom";
import { remoteClientDisconnectingVehicleSessionAtom } from "../atom/remoteClientDisconnectingVehicleSessionAtom";
import { remoteClientVehicleSessionSnapshotAtom } from "../atom/remoteClientVehicleSessionSnapshotAtom";
import useAuthenticatedCredentials from "./useAuthenticatedCredentials";

export default function useRemoteClientState() {
  const [data, setData] = useAtom(remoteClientDataAtom);
  const { clearAuthenticatedCredentials } = useAuthenticatedCredentials();
  const [vehicleSessionSnapshot, setVehicleSessionSnapshot] = useAtom(
    remoteClientVehicleSessionSnapshotAtom,
  );
  const [isDisconnectingVehicleSession, setIsDisconnectingVehicleSession] =
    useAtom(remoteClientDisconnectingVehicleSessionAtom);
  const resetRemoteClientState = useCallback(
    (initialVehicleSessionSnapshot: VehicleSessionSnapshot | null = null) => {
      setData({});
      clearAuthenticatedCredentials();
      setVehicleSessionSnapshot(initialVehicleSessionSnapshot);
      setIsDisconnectingVehicleSession(false);
    },
    [
      clearAuthenticatedCredentials,
      setData,
      setIsDisconnectingVehicleSession,
      setVehicleSessionSnapshot,
    ],
  );

  return {
    data,
    setData,
    vehicleSessionSnapshot,
    setVehicleSessionSnapshot,
    isDisconnectingVehicleSession,
    setIsDisconnectingVehicleSession,
    resetRemoteClientState,
  };
}
